import { ClipboardList, PlayCircle, CheckCircle, Users, Percent, ListChecks, CalendarCheck } from "lucide-react";
import type { StatCardConfig } from "../../common";

/** Responses overview stat cards — token icon colors, values from live queries. */
export const RESPONSES_STATS_CARDS: StatCardConfig[] = [
  {
    key: "surveysCreated",
    label: "Surveys Created",
    icon: ClipboardList,
    iconBg: "var(--color-primary-100)",
    iconColor: "var(--color-primary-700)",
  },
  {
    key: "activeSurveys",
    label: "Active",
    icon: PlayCircle,
    iconBg: "var(--color-success-light)",
    iconColor: "var(--color-success-dark)",
  },
  {
    key: "completedSurveys",
    label: "Completed",
    icon: CheckCircle,
    iconBg: "var(--color-bg-muted)",
    iconColor: "var(--color-text-secondary)",
  },
];

/** Results-page stat cards (Figma dc.html:8563) — values from live insights. */
export const INSIGHTS_STAT_CARDS: StatCardConfig[] = [
  {
    key: "completed",
    label: "Responses",
    icon: Users,
    iconBg: "var(--color-primary-100)",
    iconColor: "var(--color-primary-700)",
  },
  {
    key: "completionRate",
    label: "Response rate",
    suffix: "%",
    icon: Percent,
    iconBg: "var(--color-success-light)",
    iconColor: "var(--color-success-dark)",
  },
  {
    key: "totalAssigned",
    label: "Assigned",
    icon: ListChecks,
    iconBg: "var(--color-info-light)",
    iconColor: "var(--color-info)",
  },
  {
    key: "closedOn",
    label: "Closed on",
    icon: CalendarCheck,
    iconBg: "var(--color-warning-light)",
    iconColor: "var(--color-warning-dark)",
  },
];
